import dayjs, { type Dayjs } from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjsBusinessTime from 'dayjs-business-time';
import DateHolidays from 'date-holidays';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import minMax from 'dayjs/plugin/minMax';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(dayjsBusinessTime);
dayjs.extend(customParseFormat);
dayjs.extend(minMax);

const hd = new DateHolidays('CO');
const currentYear = dayjs().tz('America/Bogota').year();
const colombiaHolidays = [...hd.getHolidays(currentYear), ...hd.getHolidays(currentYear + 1)].map((holiday) =>
  holiday.date.slice(0, 10)
);
dayjs.setHolidays(colombiaHolidays);

export const now = (): Dayjs => {
  return dayjs().tz('America/Bogota');
};

export const date = (date?: string | number | Date | Dayjs, customFormat?: string): Dayjs => {
  try {
    if (!date) return dayjs(null);
    if (dayjs.isDayjs(date)) return date;

    // If the date is a Date object, parse and convert to Bogota
    if (date instanceof Date) return dayjs(date).tz('America/Bogota');

    // If the date has timezone info (number or string with Z/offset), parse and convert to Bogota
    const isNumberOrHasTimezoneInfo = typeof date === 'number' || /(?:Z|[+-]\d{2}:?\d{2})$/.test(date);
    if (isNumberOrHasTimezoneInfo) return dayjs(date, customFormat).tz('America/Bogota');

    // No timezone info in datetime string -> interpret as Bogota timezone
    if (customFormat) return dayjs.tz(date, customFormat, 'America/Bogota');
    else return dayjs.tz(date, 'America/Bogota');
  } catch {
    // If the date is invalid, parse and convert to Bogota
    return dayjs(date, customFormat).tz('America/Bogota');
  }
};

export const isBetween = (x: Dayjs, start: Dayjs | string | number, end: Dayjs | string | number) =>
  !x.isBefore(start) && !x.isAfter(end);

export const formatSpanish = (date: Dayjs, format: string): string => date.locale('es').format(format);
